<template>
    <div class="order-detail">
        <!-- 头部 -->
        <van-cell-group class="order-detail-number"
                        v-if="order.orderNumber || order.status">
            <van-cell title="订单编号"
                      :value="order.orderNumber"
                      v-if="order.orderNumber"> </van-cell>
            <van-cell title="订单状态"
                      v-if="order.status">
                <template>
                    {{ order.status | getName(SHOP_ORDER_STATUS)}}
                </template>
            </van-cell>
        </van-cell-group>
        <!-- 收货信息 -->
        <van-cell-group title="收货信息">
            <van-cell title="收货人"
                      :value="order.address.receiverName || ''">
            </van-cell>
            <van-cell title="电话号码"
                      :value="order.address.receiverPhone || ''">
            </van-cell>
            <van-cell title="地址"
                      :value="order.address.receiverAddress || ''">
            </van-cell>
        </van-cell-group>
        <!-- 订单信息 -->
        <van-cell-group class="order-derail-content"
                        title="商品信息">
            <van-cell v-for="(item, index) in order.goodsList"
                      :key="index"
                      :title="item.productName"
                      :value="`*${item.quantity}袋`"
                      :border="false">
            </van-cell>
        </van-cell-group>
        <van-cell-group class="order-derail-total">
            <van-cell title="总计"
                      :value="`￥${order.total || 0}`"
                      size="large"
                      value-class="order-derail-price">
            </van-cell>
        </van-cell-group>
        <div class="order-derail-fixed"
             v-if="order.status == 1">
            <van-button type="info"
                        style="width: 100%"
                        @click="save">去支付</van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    Cell,
    CellGroup,
    Image as VanImage,
    Button,
    Sticky,
    Toast,
} from 'vant';
import api_sale from '../../services/saleLogin.js';
Vue.use(VanImage);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Sticky);
Vue.use(Toast);
class isLoading {
    constructor() {
        this.loading = null;
    }
    open() {
        this.loading = Toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
        });
    }
    close() {
        if (!this.loading) {
            return;
        }
        this.loading.clear();
    }
}
const loading = new isLoading();
import { SHOP_ORDER_STATUS } from '@/mixin/global';
export default {
    name: '',
    data() {
        return {
            order: {
                address: {},
                status: 1,
            },
            SHOP_ORDER_STATUS,
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            const data = this.$route.query;
            if (data.orderNumber) {
                this.getOrderDetail(data.orderNumber);
            } else {
                const item = this.$store.state.order;
                const order = {
                    address: {
                        id: item.address.id,
                        receiverAddress: item.address.receiverAddress,
                        receiverName: item.address.receiverName,
                        receiverPhone: item.address.receiverPhone,
                    },
                    goodsList: item.goodsList,
                    total: item.goodsList
                        .map((val) => val.productPrice * val.quantity)
                        .reduce((a, b) => a + b),
                    status: 1,
                };
                this.$set(this, 'order', order);
            }
        },
        getOrderDetail(id) {
            loading.open();
            api_sale.queryOrderDetail({ orderNumber: id }).then((res) => {
                loading.close();
                const item = res.data.data[0];
                const order = {
                    total: item.total,
                    address: {
                        id: item.id,
                        receiverAddress: item.receiverAddress,
                        receiverName: item.receiverName,
                        receiverPhone: item.receiverPhone,
                    },
                    goodsList: item.productBOList.map((item) => ({
                        productName: item.productName,
                        quantity: item.productQuantity,
                        id: item.id,
                    })),
                    orderNumber: item.orderNumber,
                    status: item.status || 1,
                };
                this.$set(this, 'order', order);
            });
        },
        async save() {
            let orderNumber = this.order.orderNumber;
            if (!this.order.orderNumber) {
                const data = {
                    productVOList: this.order.goodsList.map((item) => ({
                        id: item.productId,
                        productName: item.productName,
                        productPrice: item.productPrice,
                        quantity: item.quantity,
                    })),
                    productIds: this.order.goodsList.map(
                        (item) => item.productId
                    ),
                    patientId: this.$store.getters.getUserInfo.patientId,
                    total: this.order.total,
                    addressId: this.order.address.id,
                };
                loading.open();
                const res = await api_sale.generateOrder(data);
                orderNumber = res.data.data;
                loading.close();
            }
            this.$router.replace({
                path: '/shopping-pay',
                query: {
                    orderNumber: orderNumber,
                    price: this.order.total,
                },
            });
        },
    },
};
</script>

<style lang='less'>
.order-detail {
    padding: 10px 0;
    background-color: rgb(250, 250, 250);
    height: 100%;

    .order-derail-total {
        margin-top: 10px;
    }

    .order-derail-price {
        color: red;
    }

    .order-derail-fixed {
        width: 90%;
        height: 60px;
        left: 5%;
        right: 5%;
        position: fixed;
        bottom: 0;
    }

    .order-detail-number {
        .van-cell__title {
            flex: 0.3;
        }

        .van-cell__value {
            flex: 0.7;
        }
    }
}
</style>
